import LandingPage from "../../../../src/components/landing-page";
import * as React from 'react';
export default {
  LandingPage,
  React
};